import styles from '../styles/gnb.scss';
import { dispatchToggleGameMenu } from './game-menu';
import { setPcbang } from './set-pcbang';
import { setUser } from './set-user';
import { getGNBTemplate } from './get-gnb-template';

export interface IGnbOptions {
  type?: string; // "pmang" | "bugs" | "sayclub" | "simple-pmang"
  adult?: boolean;
  userName?: string | null;
  pcbang?: boolean | null;
  font?: boolean;
  zIndex?: number;
  onClickLink: (ev: MouseEvent) => boolean;
}

let cleanUp = () => {};

let wrapper: HTMLDivElement;

let currentState: IGnbOptions = {
  type: 'pmang',
  adult: true,
  userName: '',
  pcbang: null,
  font: true,
  zIndex: 9000,
  onClickLink: (ev) => true
};

export function getGNBState(): IGnbOptions {
  return {
    ...currentState
  };
}

export function setGNBState(options: IGnbOptions): void {
  currentState = {
    ...currentState,
    ...options
  };

  if (typeof options?.userName !== 'undefined' && !options.userName) {
    currentState.adult = true; // 로그아웃시 모든 게임 목록 표시
  }

  if (wrapper) {
    cleanUp();

    wrapper.innerHTML = getGNBTemplate(currentState.type, currentState.adult);
  } else {
    wrapper = document.createElement('div');
    wrapper.className = styles.gnbPlaceholder;
    wrapper.innerHTML = getGNBTemplate(currentState.type, currentState.adult);

    wrapper.addEventListener('click', (ev) => {
      if (!ev.target) return;
      if (!(ev.target as HTMLElement).getAttribute('data-role')) return;

      let passed;
      try {
        passed = currentState.onClickLink.call(ev.target, ev);
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log('Error while invoking a click callback', err);
        passed = true;
      }

      if (!passed) {
        // eslint-disable-next-line no-param-reassign
        ev.returnValue = false; // IE8

        if (!ev.preventDefault) {
          ev.preventDefault();
        }
      }
    });

    document.body.insertAdjacentElement('afterbegin', wrapper);
  }

  wrapper.style.zIndex = currentState.zIndex?.toString() ?? '9000';

  cleanUp = dispatchToggleGameMenu(wrapper);

  setPcbang(wrapper, currentState.pcbang);

  setUser(wrapper, currentState.userName ?? '');
}
